import { useContext } from 'react';
import { Avatar } from '@zillow/constellation-10';
import { avatarContainerStyles } from '@zg-rentals/satellite-components';
import { AppContext } from '../../contexts/AppContextProvider';
import hpxLogo from '../../images/iconography/hpx-logo-tertiary.svg';
import txlLogo from '../../images/iconography/txl-logo-black.svg';

const BRAND_LOGOS = {
  hotpads: hpxLogo,
  trulia: txlLogo,
};

type SupportedBrand = keyof typeof BRAND_LOGOS;

export default function MultibrandChatAvatar(): JSX.Element | null {
  const { brand } = useContext(AppContext);

  // Early return if brand not supported
  if (!(brand in BRAND_LOGOS)) {
    return null;
  }

  const logoSrc = BRAND_LOGOS[brand as SupportedBrand].src;

  return (
    <Avatar
      css={{
        ...avatarContainerStyles,
        marginBottom: 'tighter',
        '& img': {
          objectFit: 'contain',
        },
      }}
    >
      <Avatar.Image alt={`${brand} logo`} src={logoSrc} />
    </Avatar>
  );
}
